module.exports = __webpack_public_path__ + "static/media/walking-dead.e59fd172.jpg";